// Shared audit-run label formatter. Audits are auto-titled by date, so same-day runs are
// indistinguishable in the history rail and the "What changed" comparison dropdown. Appending
// the trigger time disambiguates them. Always format from `triggeredAt` (every audit ref carries
// it) rather than the backend `title` string, so the time is available everywhere.

import { format, parseISO } from 'date-fns';

/** "Jun 15, 2026 · 2:47 PM" */
export function formatAuditLabel(triggeredAt: string): string {
  return format(parseISO(triggeredAt), 'MMM d, yyyy · h:mm a');
}
